// CourseDetail.js
import React from 'react';

const CourseDetail = ({ course }) => {
  return (
    <div className='flex flex-col justify-start items-start gap-4 h-full'>

      {course.fields.courseImage && (
        <img
          src={course.fields.courseImage.fields.file.url}
          alt={course.fields.title}
          className="w-full h-auto object-cover rounded-lg max-w-none"
        />
      )}

      <h1 className="text-4xl font-bold">{course.fields.title}</h1>
      <p className="text-justify">{course.fields.description || 'No description provided'}</p>
    </div>
  );
};

export default CourseDetail;